var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('section-title',{attrs:{"title":"Configuración de Secciones","has-line":""}}),_c('sections',{ref:"sections",attrs:{"question-types":_vm.questionTypes,"is-read-only":_vm.isReadOnly},model:{value:(_vm.model.sections),callback:function ($$v) {_vm.$set(_vm.model, "sections", $$v)},expression:"model.sections"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }